<mat-drawer-container autosize class="mat-drawer-container drawer-container">
  <!-- Main Content Area -->
  <mat-drawer-content class="drawer-main-content">
    <ng-content select="[main-content]"></ng-content>
  </mat-drawer-content>

  <!-- Right Drawer -->
  <mat-drawer
    #drawer
    mode="over"
    position="end"
    class="drawer-header-content"
    [style.width]="width"
    (backdropClick)="emitClosed()"
    (closedStart)="emitClosed()"
  >
    <!-- Header -->
    <div class="drawer-header" *ngIf="showHeader">
      <div class="drawer-title-wrapper">
        <h2 class="drawer-title">{{ title }}</h2>

        <p class="drawer-subtitle" *ngIf="subTitle">
          {{ subTitle }}
        </p>
        <ng-container
          *ngIf="resolvedHeaderTemplate"
          [ngTemplateOutlet]="resolvedHeaderTemplate"
          [ngTemplateOutletContext]="{ $implicit: headerTemplateContext }"
        ></ng-container>
      </div>
      <mat-icon class="close-icon" (click)="close()">close</mat-icon>
    </div>

    <!-- Projected Drawer Content -->
    <div class="drawer-content" [class]="drawerContentClasss">
      <ng-content select="[drawer-content]"></ng-content>
    </div>

    <!-- Footer Actions -->
    <div class="drawer-actions" *ngIf="showSubmit || showCancel">
      <button
        *ngIf="showCancel"
        mat-stroked-button
        class="cancel-button"
        (click)="onCancel()"
      >
        {{ cancelLabel }}
      </button>

      <button
        *ngIf="showSubmit"
        mat-flat-button
        color="primary"
        class="submit-button"
        [disabled]="disableSubmit"
        (click)="onSubmit()"
      >
        {{ submitLabel }}
      </button>
    </div>
  </mat-drawer>
</mat-drawer-container>
